<template>
  <div class="col-md-8" v-if="monthly">
    <div class="form-group">
      <div my-15px>
        <label class="mx-5">
          <h4>
            Banner
            <span class="small light">Recommended size 508 x 256 pixels</span>
          </h4>
        </label>

        <div class="form-group">
          <div class="d-block">
            <img
              class="img img-fluid image-preview"
              v-if="picture"
              :src="picture"
            />
          </div>
          <input
            type="file"
            accept="image/*"
            class="form-control"
            @change="uploadImage"
            ref="background_picture"
            :disabled="disabled"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { progressBarService } from "@/api/client";

export default {
  props: ["campaign"],

  data() {
    return {
      file: null,
      monthly: null,
    };
  },
  computed: {
    picture() {
      return this.campaign.monthly.background_picture;
    },

    disabled() {
      return this.campaign.status != "draft";
    },
  },
  methods: {
    async uploadImage(event) {
      const file = event.target.files[0];

      if (file.size > 5000000) {
        this.$notify("File shall not exceed 5 MB");
        event.target.files[0].value = "";
        return;
      }

      try {
        if (!file) return;
        const form = new FormData();
        form.append("background_picture", file);

        const { id } = this.campaign;

        await progressBarService.fileUpload(id, "monthly", form);

        this.$emit("updated");
        this.$notify(`Background picture updated.`);
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(`Upload background picture error.`);
      }
    },
  },

  mounted() {
    this.monthly = this.campaign.monthly;
  },
};
</script>

<style lang="scss" scoped>
.light {
  color: gray;
  font-weight: 300;
}

.image-preview {
  padding: 12px;
  min-height: 200px;
  background-color: #eaeaea;
}

.image-preview,
input[type="file"] {
  max-width: 420px;
}
</style>
